<template>
  <div class="t-conversation-item-container">
    <div class="t-conversation-item">
      <div class="avatar-box">
        <img class="t-conversation-item-avatar" :src="setConversationAvatar" />
        <div class="unread" v-if="conversation.unreadCount !== 0">
          <div class="read-text" v-if="conversation.unreadCount > 99">99+</div>
          <div class="read-text" v-else>{{ conversation.unreadCount }}</div>
        </div>
      </div>
      <div class="info-box">
        <div class="info-name-box">
          <div class="convesation-name">
            {{ conversationName }}
          </div>
          <div class="conversation-time">
            {{ timeago }}
          </div>
        </div>
        <div class="tui-conversation-lastMessage">
          {{ custom }}
        </div>
        <div class="conversation-tags">
          <el-tag size="small" type="success" effect="dark" v-if="entrySourceName">
            {{ entrySourceName || "" }}</el-tag
          >
          <el-tag size="small" v-if="platformName">
            {{ platformName || "" }}</el-tag
          >
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { caculateTimeago } from "../../../base/common";
import { getNameByValue } from "@/utils/utils.js";
import {
  platformList,
  entryList,
} from "../../../../customerService/components/dict.js";
export default {
  data() {
    return {
      platformList,
      entryList,
      conversationName: "",
      conversationAvatar: "",
      setConversationAvatar: "",
      timeago: "",
      custom: "",
      conversationList: {},
      entrySourceName: "",
      platformName: ''
    };
  },

  components: {},
  props: {
    conversation: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    conversation: {
      handler: function (conversation) {
        // 计算时间戳
        this.conversationName = this.getConversationName(conversation);
        this.setConversationAvatar =
          this.setConversationAvatarHandler(conversation);
        let time =
          conversation.lastMessage.lastTime > 0
            ? conversation.lastMessage.lastTime
            : new Date().getTime();
        this.timeago = caculateTimeago(time * 1000);
        this.$updateTimeago(conversation);
        this.getSourceTags(conversation);
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    getSourceTags(conversation) {
        this.entrySourceName = getNameByValue(this.entryList, conversation.entry_source) || "";
        this.platformName = getNameByValue(this.platformList, conversation.platform) || "";
    },
    // 先查 remark；无 remark 查 (c2c)nick/(group)name；最后查 (c2c)userID/(group)groupID
    getConversationName(conversation) {
      if (conversation.type === "@TIM#SYSTEM") {
        return "系统通知";
      } else if (conversation.type === "C2C") {
        return (
          conversation.remark ||
          conversation.userProfile.nick ||
          conversation.userProfile.userID
        );
      } else if (conversation.type === "GROUP") {
        return (
          conversation.groupProfile.name || conversation.groupProfile.groupID
        );
      } else {
        return conversation.userProfile.nick || "用户";
      }
    },

    setConversationAvatarHandler(conversation) {
      if (conversation.type === "@TIM#SYSTEM") {
        return "https://web.sdk.qcloud.com/component/TUIKit/assets/system.png";
      } else if (conversation.type === "C2C") {
        return conversation.userProfile.avatar || "/static/mine/header.png";
      } else if (conversation.type === "GROUP") {
        return (
          conversation.groupProfile.avatar ||
          "/static/static/assets/gruopavatar.svg"
        );
      } else if (conversation.type === "CUSTOMER") {
        return conversation.userProfile.avatar || "/static/mine/header.png";
      }
    },

    $updateTimeago(conversation) {
      if (conversation.conversationID) {
        conversation.lastMessage.messageForShow =
          conversation.lastMessage.messageForShow?.slice(0, 15);
        if (conversation.lastMessage.payload) {
          if (conversation.lastMessage.payload.data == "order") {
            this.custom = "[课程订单]";
          } else if (conversation.lastMessage.payload.data == "need") {
            this.custom = "[课程需求]";
          } else if (conversation.lastMessage.payload.data == "group_create") {
            this.custom = "[班级创建成功]";
          } else if (conversation.lastMessage.payload.data == "course") {
            this.custom = "[课程信息]";
          } else {
            this.custom = conversation.lastMessage.messageForShow;
          }
        }
      }

      if (conversation.lastMessage.isRevoked) {
        this.custom = "";
      }
      this.conversation = conversation;
    },

  },
};
</script>
<style lang="less" scoped>
.t-conversation-item-container {
  width: 100%;
  padding: 12px 10px;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  box-sizing: border-box;
  border-bottom: 1px solid rgb(245, 245, 245);
}

.t-conversation-item {
  width: 100%;
  display: flex;
  left: 0;
  justify-content: flex-start;
  box-sizing: border-box;
}
.avatar-box {
  position: relative;
}
.info-box {
  flex: 1;
}
.t-conversation-item-avatar {
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
}

.conversation-time {
  font-size: 12px;
  color: #999999;
}

.conversation-name {
  font-size: 14px;
  color: #333;
}

.info-name-box {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.tui-conversation-lastMessage {
  font-size: 12px;
  color: #999999;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 190px;
}
.unread {
  position: absolute;
  top: -4px;
  right: 10px;
  padding: 0 6px;
  height: 15px;
  border-radius: 15px;
  color: #ffffff;
  background-color: red;
}
.read-text {
  line-height: 15px;
  font-size: 10px;
}
.conversation-tags{
    margin-top: 8px;
    .el-tag{
      margin-right: 10px;
    }
}
</style>
